import './HoneycombChart.css';
export var graphContainer = '_p8cogi0-3-5-0';